import { Injectable, Output } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, catchError, map, of } from 'rxjs';
import { ConfirmComponent } from '../shared/components/confirm/confirm.component';
import { ExportComponent } from '../shared/components/export/export.component';
import { AlertdialogComponent } from '../shared/components/alertdialog/alertdialog.component';
import * as XLSX from 'xlsx-js-style';
import { MessageConfirmRquest } from '../shared/components/confirm/domain/message-confirm-request';
import { FormateoFechas, Parametros, Parametros_2 } from './domain/services-domain';
import { ListarTodosWebRequest, requestejecutivo } from '../proforma/domain/request/proforma_request';
import { ProformaRepository } from '../proforma/domain/proforma.repository';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CryptoRepository } from '../interfaces/crypto-repository';
import { LoadingScreenComponent } from '../shared/components/loading-screen/loading-screen.component';
import { StorageService } from './storage.service';
import { PricingRepository } from '../supply/pricing/servicio/pricing.repository';
import { ConfirmationService } from 'primeng/api';
import { AlertDialogPrimeComponentComponent } from '../shared/components/alert-dialog-prime-component/alert-dialog-prime-component.component';
import { listarEntidadesRequest } from '../parametros/domain/parametros.request';
import { parametrosRepository } from '../parametros/servicio/parametros.repository';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { DialogFormularioComponent } from '../cliente/presentacion/components/dialog-formulario/dialog-formulario.component';
import { ALoadingScreenComponent } from '../shared/componentes/a-loading-screen/a-loading-screen.component';
import { newmetadate } from '../shared/components/datatable/domain/datatable-domain';
import { itemsArchivosGenericoDTO } from '../interfaces/util.interface';

//@ts-ignore
@Injectable({
  providedIn: 'root'
})

export class UtilService {

  @Output() parametros: Parametros[] = [];
  @Output() parametros_v2: Parametros[] = [];
  constructor(
    private readonly dialog: MatDialog,
    private readonly notifier: MatSnackBar,
    private readonly bottomSheet: MatBottomSheet,
    private readonly proformaService: ProformaRepository,
    private readonly dialogService: DialogService,
    private readonly crypto: CryptoRepository,
    private readonly storage: StorageService,
    private readonly servParametros: parametrosRepository,
    private readonly repopricing: PricingRepository
  ) {
    this.ngOnInit()
  }


  async Parametros(): Promise<Parametros[]> {
    const datos: Parametros[] = []
    try {
      const requestEjecutivo = <requestejecutivo>{}
      requestEjecutivo.entc_Codigo = 3

      const response = await this.proformaService.listarejecutivo(requestEjecutivo).toPromise()

      for (let i = 0; i < response.datos.result.length; i++) {
        const item: Parametros = {
          tipo: 'EJC',
          nombre: response.datos.result[i].nombreejecutivo,
          codigo: response.datos.result[i].codejecutivo.toString(),
          via: null,
          regimen: null,
          lineaNegocio: null,
          adicional1: null,
          adicional2: null,
          adicional3: null,
          pais: null,
          codpais: null
        };
        datos.push(item);
      }
    } catch (error) {

    }

    try {
      const request2 = <ListarTodosWebRequest>{}
      request2.tipo = null
      request2.codigo = null
      const response2 = await this.proformaService.ListarTodosWeb(request2).toPromise()

      for (let i = 0; i < response2.datos.result.length; i++) {
        const item: Parametros = {
          tipo: response2.datos.result[i].tipo,
          nombre: response2.datos.result[i].nombre.toUpperCase(),
          codigo: response2.datos.result[i].codigo.toString(),
          via: response2.datos.result[i].via,
          regimen: response2.datos.result[i].regimen,
          lineaNegocio: response2.datos.result[i].lineaNegocio,
          adicional1: response2.datos.result[i].adicional1,
          adicional2: response2.datos.result[i].adicional2,
          adicional3: response2.datos.result[i].adicional3,
          pais: response2.datos.result[i].pais,
          codpais: response2.datos.result[i].codpais
        };
        datos.push(item);
      }
    } catch (error) {

    }

    return datos
  }

  async ngOnInit(): Promise<void> {
    // this.parametros = await this.Parametros()//COMENTADO 2DBLE
  }

  async loadParametros(): Promise<Parametros[]> {
    const datos: Parametros[] = [];
    try {
      const requestEjecutivo: requestejecutivo = { entc_Codigo: 3 };
      const response = await this.proformaService.listarejecutivo(requestEjecutivo).toPromise();

      for (const item of response.datos.result) {
        datos.push({
          tipo: 'EJC',
          nombre: item.nombreejecutivo,
          codigo: item.codejecutivo.toString(),
          via: null,
          regimen: null,
          lineaNegocio: null,
          adicional1: null,
          adicional2: null,
          adicional3: null,
          pais: null,
          codpais: null
        });
      }
    } catch (error) {
      console.error('Error fetching ejecutivos:', error);
    }

    try {
      const request2: ListarTodosWebRequest = { tipo: null, codigo: null };
      const response2 = await this.proformaService.ListarTodosWeb(request2).toPromise();

      for (const item of response2.datos.result) {
        datos.push({
          tipo: item.tipo,
          nombre: item.nombre.toUpperCase(),
          codigo: item.codigo.toString(),
          via: item.via,
          regimen: item.regimen,
          lineaNegocio: item.lineaNegocio,
          adicional1: item.adicional1,
          adicional2: item.adicional2,
          adicional3: item.adicional3,
          pais: item.pais,
          codpais: item.codpais
        });
      }
    } catch (error) {
      console.error('Error fetching todos web:', error);
    }

    return datos;
  }
  async loadParametros_v2(): Promise<Parametros_2[]> {
    const datos: Parametros_2[] = [];
    try {
      const requestEjecutivo: requestejecutivo = { entc_Codigo: 3 };
      const response = await this.proformaService.listarejecutivo(requestEjecutivo).toPromise();

      for (const item of response.datos.result) {
        datos.push({
          id: null,
          tipo: 'EJC',
          nombre: item.nombreejecutivo,
          codigo: item.codejecutivo.toString(),
          via: null,
          regimen: null,
          lineaNegocio: null,
          adicional1: null,
          adicional2: null,
          adicional3: null,
          pais: null,
          codpais: null
        });
      }
    } catch (error) {
      console.error('Error fetching ejecutivos:', error);
    }

    try {
      const request2: ListarTodosWebRequest = { tipo: null, codigo: null };
      const response2 = await this.proformaService.ListarTodosWeb(request2).toPromise();

      for (const item of response2.datos.result) {
        datos.push({
          id: null,
          tipo: item.tipo,
          nombre: item.nombre.toUpperCase(),
          codigo: item.codigo.toString(),
          via: item.via,
          regimen: item.regimen,
          lineaNegocio: item.lineaNegocio,
          adicional1: item.adicional1,
          adicional2: item.adicional2,
          adicional3: item.adicional3,
          pais: item.pais,
          codpais: item.codpais
        });
      }
    } catch (error) {
      console.error('Error fetching todos web:', error);
    }

    return datos;
  }

  async loadTiposClientes(): Promise<any[]> {
    try {
      const response = await this.proformaService.listarTiposClientes().toPromise();
      return response?.result

      return response.result
    } catch (error) {
      console.error('Error fetching ejecutivos:', error);
      return []
    }

    ;
  }

  async getParametros(): Promise<Parametros[]> {

    if (this.parametros.length === 0) {
      this.parametros = await this.loadParametros();
    }
    return this.parametros;
  }

  openModal(classComponent: any,
    options: { [s: string]: string | boolean | number },
    returnReference: boolean = false
  ): Observable<any> | any {

    const reference: MatDialogRef<typeof classComponent> =
      this.dialog.open(
        classComponent,
        options
      );

    if (returnReference) {

      return reference;

    } else {

      return reference.afterClosed();

    }

  }

  showMessage(message: string): void {
    this.notifier.open(message, null,
      {
        duration: 5000, horizontalPosition: 'end',
        verticalPosition: 'top', panelClass: ['blue-snackbar']
      })
  }

  showMessageError(message: string): void {
    this.notifier.open(message, null,
      {
        duration: 5000, horizontalPosition: 'end',
        verticalPosition: 'top', panelClass: ['message-error']
      })
  }

  confirm(message: string = ""): Observable<any> {

    const referenceConfirm = this.openModal(
      ConfirmComponent,
      {
        with: "320px",
        disableClose: true,
      },
      true
    );

    if (message) {

      referenceConfirm.componentInstance.message = message;
    }
    return referenceConfirm.afterClosed();

  }

  ShowMessageConfirm(data: MessageConfirmRquest): Observable<any> {

    const referenceConfirm = this.openModal(
      ConfirmComponent,
      {
        with: "320px",
        disableClose: true,
      },
      true
    );

    if (data.mensaje) {

      referenceConfirm.componentInstance.message = data.mensaje;
    }
    return referenceConfirm.afterClosed();

  }

  openSheet() {
    this.bottomSheet.open(ExportComponent);
  }

  formatearfecha(fecha, formato: FormateoFechas) {
    if (fecha === null || fecha === "") {
      return ""
    }
    var fechaFormateada = '';
    var fechaDate: Date
    if (fecha != null || fecha != '' || fecha != undefined) {
      fecha = fecha instanceof Date ? fecha : new Date(fecha);

      if (formato === 'ddmmyyyy_hhmmss') {
        const dia = String(fecha.getDate()).padStart(2, '0');
        const mes = String(fecha.getMonth() + 1).padStart(2, '0');
        const anio = fecha.getFullYear();
        const horas = String(fecha.getHours()).padStart(2, '0');
        const minutos = String(fecha.getMinutes()).padStart(2, '0');
        const segundos = String(fecha.getSeconds()).padStart(2, '0');
        fechaFormateada = `${dia}-${mes}-${anio} ${horas}:${minutos}:${segundos}`;
      }
      else if (formato === 'dd/mm/yyyy') {
        fechaFormateada = String(fecha.getDate()).padStart(2, '0') + '/' + String(fecha.getMonth() + 1).padStart(2, '0') + '/' + fecha.getFullYear();
      } else if (formato === 'mm/yyyy') {
        const nombresMeses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
        const mesAbreviado = nombresMeses[fecha.getMonth()];
        fechaFormateada = mesAbreviado + '/' + fecha.getFullYear();
      } else if (formato === 'dd-mm-yyyy') {
        fechaFormateada = String(fecha.getDate()).padStart(2, '0') + '-' + String(fecha.getMonth() + 1).padStart(2, '0') + '-' + fecha.getFullYear();
      } else if (formato === 'yyyy-mm-dd') {
        fechaFormateada = fecha.getFullYear() + '-' + String(fecha.getMonth() + 1).padStart(2, '0') + '-' + String(fecha.getDate()).padStart(2, '0');
      } else if (formato === 'yyyy/mm/dd') {
        fechaFormateada = fecha.getFullYear() + '/' + String(fecha.getMonth() + 1).padStart(2, '0') + '/' + String(fecha.getDate()).padStart(2, '0');
      } else if (formato === 'hh:mm') {
        fechaFormateada = String(fecha.getHours()).padStart(2, '0') + ':' + String(fecha.getMinutes()).padStart(2, '0');
      } else if (formato === 'hh:mm:ss') {
        fechaFormateada = String(fecha.getHours()).padStart(2, '0') + ':' + String(fecha.getMinutes()).padStart(2, '0') + ':' + String(fecha.getSeconds()).padStart(2, '0');
      } else if (formato === 'dd/mm/yyyy hh:mm') {
        // fechaFormateada = String(fecha.getDate()).padStart(2, '0') + '/' + String(fecha.getMonth() + 1).padStart(2, '0') + '/' + fecha.getFullYear() + ' ' +
        //   String(fecha.getUTCHours()).padStart(2, '0') + ':' +  // Cambio aquí
        //   String(fecha.getMinutes()).padStart(2, '0');
        fechaFormateada = String(fecha.getDate()).padStart(2, '0') + '/' +
          String(fecha.getMonth() + 1).padStart(2, '0') + '/' +
          fecha.getFullYear() + ' ' +
          String(fecha.getHours()).padStart(2, '0') + ':' +
          String(fecha.getMinutes()).padStart(2, '0');
      } else if (formato === 'yyyy-MM-ddTHH:mm:ss') {
        fechaFormateada = fecha.toISOString().slice(0, 19).replace('T', ' ');
      } else if (formato === 'fechaInicioHora') {
        fechaDate = new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate(), 0, 0, 0);
      } else if (formato === 'fechaFinHora') {
        fechaDate = new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate(), 23, 59, 59);
      } else if (formato === 'dd/mm') {
        fechaFormateada = String(fecha.getDate()).padStart(2, '0') + '/' + String(fecha.getMonth() + 1).padStart(2, '0');
      } else if (formato === 'yyyy-mm-dd hh:mm:ss') {

        if (fecha == '' || fecha == undefined) {
          fechaFormateada = ''
        } else {


          const dia = String(fecha.getDate()).padStart(2, '0');
          const mes = String(fecha.getMonth() + 1).padStart(2, '0');
          const anio = fecha.getFullYear();
          const horas = String(fecha.getHours()).padStart(2, '0');
          const minutos = String(fecha.getMinutes()).padStart(2, '0');
          const segundos = String(fecha.getSeconds()).padStart(2, '0');

          fechaFormateada = `${dia}/${mes}/${anio} ${horas}:${minutos}:${segundos}`;
        }

      }
      else if (formato === 'fechaconT') {

        const dia = String(fecha.getDate()).padStart(2, '0');
        const mes = String(fecha.getMonth() + 1).padStart(2, '0');
        const anio = fecha.getFullYear();
        const horas = String(fecha.getHours()).padStart(2, '0');
        const minutos = String(fecha.getMinutes()).padStart(2, '0');
        const segundos = String(fecha.getSeconds()).padStart(2, '0');

        fechaFormateada = `${anio}-${mes}-${dia}T${horas}:${minutos}:${segundos}`;



      } else if (formato === 'dateString') {
        // Definir las opciones para formatear la fecha con el día de la semana
        const opciones: Intl.DateTimeFormatOptions = {
          weekday: 'long', // Muestra el nombre completo del día de la semana (ej. 'lunes', 'martes')
          day: '2-digit', // Muestra el día con dos dígitos (ej. '25')
          month: 'long', // Muestra el nombre completo del mes (ej. 'octubre')
          year: 'numeric' // Muestra el año completo (ej. '2024')
        };

        // Obtener la fecha formateada (incluyendo el día de la semana)
        fechaFormateada = fecha.toLocaleDateString('es-ES', opciones);
      } else if (formato === 'fecha_hora') {
        const dia = String(fecha.getDate()).padStart(2, '0');
        const mes = String(fecha.getMonth() + 1).padStart(2, '0');
        const anio = fecha.getFullYear();
        const horas = String(fecha.getHours()).padStart(2, '0');
        const minutos = String(fecha.getMinutes()).padStart(2, '0');
        fechaFormateada = `${dia}${mes}${anio}_${horas}${minutos}`;
      }
    } else {
      fechaFormateada = ''
    }

    return fechaFormateada;
  }

  formateaFechaHoras(fecha, formato: string) {

    var fechaFormateada = '1900-01-01 00:00:00'
    if (fecha != "") {
      if (formato === 'fechaInicioHora') {
        fechaFormateada = fecha.getFullYear() + '-' +
          (fecha.getMonth() + 1).toString().padStart(2, '0') + '-' +
          fecha.getDate().toString().padStart(2, '0') + ' 00:00:00';
      } else if (formato === 'fechaFinHora') {
        fechaFormateada = fecha.getFullYear() + '-' +
          (fecha.getMonth() + 1).toString().padStart(2, '0') + '-' +
          fecha.getDate().toString().padStart(2, '0') + ' 23:59:59';
      }
    }
    return fechaFormateada
  }

  NuevoMensaje(titulo?: string, mensaje?: string, icono?: string, referencia?: any, cerrar: boolean = false, autocerrar: boolean = false, tiempo: number = 3000, tipo: string = 'ok') {

    const dialogRef = this.dialog.open(AlertdialogComponent, {
      data: { message: mensaje, icono: icono, titulo: titulo, tipo: tipo },
      panelClass: 'transparent-background'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (cerrar) {
        referencia?.close();
      }
    });

    if (autocerrar == true) {
      setTimeout(() => {
        dialogRef.close();
      }, tiempo);
    }
  }

  ShowMessage(options: {
    titulo?: string,
    mensaje?: string,
    icono?: string,
    cerrar?: boolean,
    referencia?: any,
    autocerrar?: boolean,
    tiempo?: number,
    tipo?: "ok" | "warning" | "error" | "",
    detalle?: string,
    pregunta?: {
      onAccept?: () => void,
      onReject?: () => void,
    },
    textoBtn?: {
      textoBtnOpcion1?: string,
      textoBtnOpcion2?: string,
    },
    optionBtn?: {
      optionBtn1?: boolean
      optionBtn2?: boolean
    }
  }): Promise<boolean> {
    const showMessageOptions = {
      titulo: options.titulo || '',
      mensaje: options.mensaje || '',
      icono: options.icono || 'icono-predeterminado',
      tipo: options.tipo || 'ok',
      referencia: options.referencia,
      cerrar: options.cerrar || false,
      autocerrar: options.autocerrar || false,
      tiempo: options.tiempo || 3000,
      detalle: options.detalle || '',
      pregunta: options.pregunta || null,
      textoBtn: options.textoBtn || '',
      optionBtn: options.optionBtn || '',
    };

    const dialogRef = this.dialog.open(AlertdialogComponent, {
      data: {
        message: showMessageOptions.mensaje, icono: showMessageOptions.icono,
        titulo: showMessageOptions.titulo, tipo: showMessageOptions.tipo, detalle:
          showMessageOptions.detalle, pregunta: !!showMessageOptions.pregunta,
        textoBtn: showMessageOptions.textoBtn, optionBtn: showMessageOptions.optionBtn
      },
      panelClass: 'transparent-background',

    });

    return new Promise<boolean>((resolve) => {
      if (showMessageOptions.pregunta) {
        dialogRef.afterClosed().subscribe(async (result: boolean) => {
          if (result) {
            if (showMessageOptions.pregunta?.onAccept) {
              showMessageOptions.pregunta.onAccept();
              resolve(true);
            }
          } else {
            showMessageOptions.pregunta?.onReject?.();
            resolve(false);
          }
        });
      } else {
        // Suscribirse al evento afterClosed del diálogo normal sin pregunta
        dialogRef.afterClosed().subscribe(result => {
          // Cerrar la referencia si se proporciona la opción de cerrar
          if (showMessageOptions.cerrar) {
            showMessageOptions.referencia?.close();
            resolve(false);
          }
        });
      }
    });

    // Autocerrar el diálogo después del tiempo especificado si se proporciona la opción de autocerrar
    if (showMessageOptions.autocerrar) {
      setTimeout(() => {
        dialogRef.close();
      }, showMessageOptions.tiempo);
    }
  }

  formatearNumero(numero: number): string {
    // Verificar si el número tiene decimales
    const tieneDecimales = numero % 1 !== 0;

    // Convertir el número a string y separar las partes enteras y decimales
    const [parteEntera, parteDecimal] = numero.toFixed(2).split('.');

    // Agregar separadores de miles a la parte entera
    const parteEnteraFormateada = parteEntera.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    // Si el número original tiene decimales, mantenerlos, de lo contrario agregar '00'
    const parteDecimalFormateada = tieneDecimales ? '.' + parteDecimal : '.00';

    // Unir las partes y devolver el resultado
    return parteEnteraFormateada + parteDecimalFormateada;
  }

  ExportarExcel(colecciones: { data: any[], cabeceras: string[] }[], FileName: string = "documento.xlsx", footer: boolean = true, totales: any[] = []) {
    if (colecciones.length > 0) {
      const wb: XLSX.WorkBook = XLSX.utils.book_new();

      for (let index = 0; index < colecciones.length; index++) {
        const data = colecciones[index].data;
        this.NewExcelSheet(data, ['ITEM', 'PRODUCTO', 'PRECIO'], wb, footer, totales);
      }

      XLSX.writeFile(wb, FileName);

    } else {
      console.log('No hay colecciones para exportar');
    }
  }

  ExportarExcel_V2(colecciones: { data: any[], cabeceras: string[] }[], FileName: string = "documento.xlsx", footer: boolean = true, totales: any[] = [], filasPrevias: string[][] = []) {
    if (colecciones.length > 0) {
      const wb: XLSX.WorkBook = XLSX.utils.book_new();

      // Iterar sobre cada colección de datos
      for (let index = 0; index < colecciones.length; index++) {
        const data = colecciones[index].data;
        this.NewExcelSheet_v2(data, ['ITEM', 'PRODUCTO', 'PRECIO'], wb, footer, totales, filasPrevias);
      }

      // Exportar el archivo
      XLSX.writeFile(wb, FileName);

    } else {
      console.log('No hay colecciones para exportar');
    }
  }

  ExportarExcelTreeTable(colecciones: { data: any[], cabeceras: string[] }[], FileName: string = "documento.xlsx", footer: boolean = true, totales: any[] = [], mergeInfo: any[] = []) {
    if (colecciones.length > 0) {
      const wb: XLSX.WorkBook = XLSX.utils.book_new();

      // Pasa la información de mergeInfo a la hoja
      for (let index = 0; index < colecciones.length; index++) {
        const data = colecciones[index].data;
        // Pasa mergeInfo al crear la hoja
        this.NewExcelSheetTreeTable(data, Object.keys(data[0]), wb, footer, totales, mergeInfo);
      }

      XLSX.writeFile(wb, FileName);

    } else {
      console.log('No hay colecciones para exportar');
    }
  }

  NewExcelSheet(dato: any[], cabeceras: string[], wb, footer: boolean = true, coltotales: number[] = []) {
    console.log(dato);
    if (dato.length > 0) {

      // Creamos una copia de los datos para trabajar con ellos
      let datos: any[] = dato.slice();

      let inicioy = 0;
      let iniciox = 0;
      let iniciototales = 7;

      // Establecemos las dimensiones de la hoja (filas y columnas)
      const y = datos.length;  // Cantidad de filas
      const x = (datos.length > 0 ? Object.keys(datos[0]).length : 0);  // Cantidad de columnas

      // Inicializamos la estructura de la hoja con datos vacíos
      const data = [];
      //esto es comentado hasta saber por que se crear 30 columnas en blanco
      // for (let i = 1; i <= y + inicioy + 30; i++) { // Aseguramos que haya suficiente espacio para filas y títulos
      //   const row = [];
      //   for (let j = 1; j <= x + 6 + iniciox; j++) { // Aumentamos las columnas si es necesario
      //     row.push('');
      //   }
      //   data.push(row);
      // }

      for (let i = 1; i <= y + inicioy; i++) { // Aseguramos que haya suficiente espacio para filas y títulos
        const row = [];
        for (let j = 1; j <= x + iniciox; j++) { // Aumentamos las columnas si es necesario
          row.push('');
        }
        data.push(row);
      }

      // Creamos la hoja a partir de la estructura de datos vacíos
      const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);

      const colinicio = this.getExcelColumnName(iniciox);

      // Agregamos las cabeceras si tenemos datos
      XLSX.utils.sheet_add_json(ws, [datos[0]], { header: Object.keys(datos[0]), skipHeader: false, origin: colinicio + (inicioy + 1) });

      // Agregamos el contenido (si hay más de una fila)
      if (datos.length > 1) {
        for (let index = 1; index < datos.length; index++) {
          XLSX.utils.sheet_add_json(ws, [datos[index]], { header: Object.keys(datos[index]), skipHeader: true, origin: colinicio + (inicioy + index + 2) });
        }
      }

      // Calculamos las coordenadas de la última celda
      let coorx = x - 1 + (iniciox);
      let coory = y + (inicioy);
      let totales = footer ? (coory + 1) : coory;

      // Estilizamos la hoja
      for (var i in ws) {
        if (typeof ws[i] != 'object') continue;
        let cell = XLSX.utils.decode_cell(i);

        // Estilo general para todas las celdas
        ws[i].s = {
          font: {
            name: 'Aptos Narrow',
            sz: 10,
          },
          fill: {
            patternType: 'solid',
            fgColor: { rgb: 'ffffff' },
          },
          alignment: {
            vertical: 'center',
            horizontal: 'center',
            wrapText: false,
          }
        };

        // Configuración de bordes
        if (cell.r <= totales && cell.c <= coorx && cell.r >= inicioy && cell.c >= iniciox) {
          ws[i].s.border = {
            top: { style: 'medium' },
            bottom: { style: 'medium' },
            left: { style: 'medium' },
            right: { style: 'medium' },
          };

          // Estilo de cabecera
          if (cell.r == inicioy) {
            ws[i].s.fill = {
              patternType: 'solid',
              fgColor: { rgb: '156082' },
            };
            ws[i].s.font = {
              name: 'Aptos Narrow',
              sz: 10,
              bold: true,
              color: { rgb: 'ffffff' },
            };
            ws[i].s.border.left = cell.c == iniciox ? { style: 'medium' } : { style: 'thin' };
            ws[i].s.border.right = cell.c == coorx ? { style: 'medium' } : { style: 'thin' };
          }
          // Estilo de totales (si corresponde)
          else if (cell.r == totales) {
            ws[i].s.border.left = cell.c == iniciox ? { style: 'medium' } : { style: 'thin' };
            ws[i].s.border.right = cell.c == coorx ? { style: 'medium' } : { style: 'thin' };
            ws[i].s.border.top = { style: 'none' };
            ws[i].s.border.bottom = { style: 'thin' };

            if (coltotales.length > 0) {

              for (var k = 0; k <= coorx; k++) {
                const col = this.getExcelColumnName(k);
                const estaAlMenosUno = coltotales.some(valor => coltotales.includes(k));

                if (estaAlMenosUno == true) {

                  XLSX.utils.sheet_set_array_formula(ws, {
                    s: { c: k, r: totales }, // Coordenada de inicio
                    e: { c: k, r: totales }  // Coordenada de fin
                  }, "SUM(" + col + (inicioy + 2) + ":" + col + "" + (totales) + ")",)

                }

              }
            }
          }
          // Estilo de celdas de contenido
          else {
            ws[i].s.border = {
              top: { style: 'none' },
              bottom: { style: 'none' },
              left: cell.c == iniciox ? { style: 'medium' } : { style: 'thin' },
              right: cell.c == coorx ? { style: 'medium' } : { style: 'thin' },
            };
          }
        }
      }

      // Configuración de las columnas (anchos de columna)
      const colsConfig = Array.from({ length: coorx + 1 }, (_, index) => ({
        wch: index === 0 ? 20 : (index === 1 ? 27 : (index === 2 ? 50 : (index === 5 ? 50 : 18)))
      }));
      ws['!cols'] = colsConfig;

      // Añadimos la hoja al libro de trabajo
      XLSX.utils.book_append_sheet(wb, ws, 'Hoja 1');

    } else {
      console.log('El array está vacío - no hay datos para exportar');
    }
  }

  NewExcelSheet_v2(dato: any[], cabeceras: string[], wb: XLSX.WorkBook, footer: boolean = true, coltotales: number[] = [], filasPrevias: string[][] = []) {
    console.log(dato);
    if (dato.length > 0) {

      // Creamos una copia de los datos para trabajar con ellos
      let datos: any[] = dato.slice();

      let inicioy = 0;
      let iniciox = 0;
      let filaIndex = 0;  // Se inicializa el índice de filas previas
      // let iniciototales = tablaDesdeFila + 2;  // Ajustamos para los totales (después de la tabla)

      // Establecemos las dimensiones de la hoja (filas y columnas)
      const y = datos.length;  // Cantidad de filas
      const x = (datos.length > 0 ? Object.keys(datos[0]).length : 0);  // Cantidad de columnas

      // Inicializamos la estructura de la hoja con datos vacíos
      const data = [];
      for (let i = 1; i <= y + inicioy + 30; i++) { // Aseguramos que haya suficiente espacio para filas y títulos
        const row = [];
        for (let j = 1; j <= x + 6 + iniciox; j++) { // Aumentamos las columnas si es necesario
          row.push('');
        }
        data.push(row);
      }

      // Creamos la hoja a partir de la estructura de datos vacíos
      const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);

      // Agregar las filas previas, con líneas vacías entre ellas
      filasPrevias.forEach(fila => {
        // Si fila es un arreglo, lo agregamos tal cual
        XLSX.utils.sheet_add_aoa(ws, [fila], { origin: { r: filaIndex, c: 0 } });
        filaIndex++;  // Avanzamos al siguiente índice
      });

      // Agregamos las cabeceras en la fila donde comienza la tabla
      const colinicio = this.getExcelColumnName(iniciox);
      XLSX.utils.sheet_add_json(ws, [datos[0]], { header: Object.keys(datos[0]), skipHeader: false, origin: colinicio + (inicioy + filaIndex + 1) });

      // Agregamos el contenido (si hay más de una fila)
      if (datos.length > 1) {
        for (let index = 1; index < datos.length; index++) {
          XLSX.utils.sheet_add_json(ws, [datos[index]], { header: Object.keys(datos[index]), skipHeader: true, origin: colinicio + (inicioy + filaIndex + index + 2) });
        }
      }

      // Calculamos las coordenadas de la última celda
      let coorx = x - 1 + (iniciox);
      let coory = y + (inicioy) + filaIndex;
      let totalesCoord = footer ? (coory + 1) : coory;

      // Estilizamos la hoja
      for (var i in ws) {
        if (typeof ws[i] != 'object') continue;
        let cell = XLSX.utils.decode_cell(i);

        // Estilo general para todas las celdas
        ws[i].s = {
          font: {
            name: 'Aptos Narrow',
            sz: 10,
          },
          fill: {
            patternType: 'solid',
            fgColor: { rgb: 'ffffff' },
          },
          alignment: {
            vertical: 'center',
            horizontal: 'center',
            wrapText: false,
          }
        };

        // Configuración de bordes
        if (cell.r <= totalesCoord && cell.c <= coorx && cell.r >= inicioy && cell.c >= iniciox) {
          ws[i].s.border = {
            top: { style: 'medium' },
            bottom: { style: 'medium' },
            left: { style: 'medium' },
            right: { style: 'medium' },
          };

          // Estilo de cabecera
          if (cell.r == (inicioy + filaIndex)) {  // La cabecera se pinta en la fila donde comienza la tabla
            ws[i].s.fill = {
              patternType: 'solid',
              fgColor: { rgb: '156082' },
            };
            ws[i].s.font = {
              name: 'Aptos Narrow',
              sz: 10,
              bold: true,
              color: { rgb: 'ffffff' },
            };
            ws[i].s.border.left = cell.c == iniciox ? { style: 'medium' } : { style: 'thin' };
            ws[i].s.border.right = cell.c == coorx ? { style: 'medium' } : { style: 'thin' };
          }
          // Estilo de totales (si corresponde)
          else if (cell.r == totalesCoord) {
            ws[i].s.border.left = cell.c == iniciox ? { style: 'medium' } : { style: 'thin' };
            ws[i].s.border.right = cell.c == coorx ? { style: 'medium' } : { style: 'thin' };
            ws[i].s.border.top = { style: 'none' };
            ws[i].s.border.bottom = { style: 'thin' };
          }
          // Estilo de celdas de contenido
          else {
            ws[i].s.border = {
              top: { style: 'none' },
              bottom: { style: 'none' },
              left: cell.c == iniciox ? { style: 'medium' } : { style: 'thin' },
              right: cell.c == coorx ? { style: 'medium' } : { style: 'thin' },
            };
          }
        }
      }

      // Configuración de las columnas (anchos de columna)
      const colsConfig = Array.from({ length: coorx + 1 }, (_, index) => ({
        wch: index === 0 ? 20 : (index === 1 ? 27 : (index === 2 ? 50 : (index === 5 ? 50 : 18)))
      }));
      ws['!cols'] = colsConfig;

      // Añadimos la hoja al libro de trabajo
      XLSX.utils.book_append_sheet(wb, ws, 'Hoja 1');

    } else {
      console.log('El array está vacío - no hay datos para exportar');
    }
  }

  NewExcelSheetTreeTable(dato: any[], cabeceras: string[], wb, footer: boolean = true, coltotales: number[] = [], mergeInfo: any[] = []) {
    console.log(dato);
    if (dato.length > 0) {

      // Creamos una copia de los datos para trabajar con ellos
      let datos: any[] = dato.slice();

      let inicioy = 0;
      let iniciox = 0;

      // Establecemos las dimensiones de la hoja (filas y columnas)
      const y = datos.length;
      const x = (datos.length > 0 ? Object.keys(datos[0]).length : 0);

      const data = [];
      for (let i = 1; i <= y + inicioy + 30; i++) {
        const row = [];
        for (let j = 1; j <= x + 6 + iniciox; j++) {
          row.push('');
        }
        data.push(row);
      }
      const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);
      const colinicio = this.getExcelColumnName(iniciox);

      // Agregamos las cabeceras (Fila: inicioy + 1)
      XLSX.utils.sheet_add_json(ws, [datos[0]], { header: Object.keys(datos[0]), skipHeader: false, origin: colinicio + (inicioy + 1) });
      // Agregamos el contenido (a partir de la Fila: inicioy + 2)
      if (datos.length >= 1) { // Cambié de > 1 a >= 1
        // Si solo hay una fila, ya se agregó arriba, por lo que este bucle no correrá si es 1.
        for (let index = 1; index < datos.length; index++) {
          XLSX.utils.sheet_add_json(ws, [datos[index]], { header: Object.keys(datos[index]), skipHeader: true, origin: colinicio + (inicioy + index + 2) });
        }
      }

      // APLICAR LA COMBINACIÓN DE CELDAS (MERGE) Y ESTILO
      if (mergeInfo.length > 0) {
        ws['!merges'] = mergeInfo;

        // ... (Tu código para aplicar estilos a la celda de inicio del merge) ...
        mergeInfo.forEach(merge => {
          const cellRef = XLSX.utils.encode_cell(merge.s);

          // 1. Aseguramos que la celda de inicio de la combinación exista.
          if (!ws[cellRef]) {
            ws[cellRef] = { t: 's', v: '' };
          }

          // 2. Aplicamos estilos a la celda de inicio de la combinación
          ws[cellRef].s = {
            // ... (Estilos de alineación y bordes de la celda combinada) ...
            alignment: {
              vertical: 'center',
              horizontal: 'center',
              wrapText: true, // <--- CAMBIO CLAVE: Ajustar texto solo para la celda combinada
            },
            border: {
              top: { style: 'medium' },
              bottom: { style: 'medium' },
              left: { style: 'medium' },
              right: { style: 'medium' },
            },
            font: {
              name: 'Aptos Narrow',
              sz: 10,
              bold: true,
              color: { rgb: '000000' },
            },
            fill: {
              patternType: 'solid',
              fgColor: { rgb: 'D9D9D9' },
            }
          };
        });
      }

      // Calculamos las coordenadas de la última celda
      let coorx = x - 1 + (iniciox);
      let coory = y + (inicioy);
      let totales = footer ? (coory + 1) : coory;

      // Estilizamos la hoja
      for (var i in ws) {
        if (typeof ws[i] != 'object') continue;
        let cell = XLSX.utils.decode_cell(i);

        // Estilo general para todas las celdas (incluyendo ajuste de texto)
        ws[i].s = {
          font: {
            name: 'Aptos Narrow',
            sz: 10,
          },
          fill: {
            patternType: 'solid',
            fgColor: { rgb: 'ffffff' },
          },
          alignment: {
            vertical: 'center',
            horizontal: 'left', // Cambiado a 'left' para los datos (más legible)
            wrapText: true, // <--- CAMBIO CLAVE: Ajustar texto en todas las celdas
          }
        };

        // Configuración de bordes para toda la tabla (datos y cabecera)
        if (cell.r <= totales && cell.c <= coorx && cell.r >= inicioy && cell.c >= iniciox) {
          // Aplicar borde grueso alrededor de toda la tabla y bordes delgados internos
          ws[i].s.border = {
            top: cell.r === inicioy ? { style: 'medium' } : { style: 'thin' },
            bottom: cell.r === totales ? { style: 'medium' } : { style: 'thin' },
            left: cell.c === iniciox ? { style: 'medium' } : { style: 'thin' },
            right: cell.c === coorx ? { style: 'medium' } : { style: 'thin' },
          };

          // Estilo de cabecera (mantenido de tu código)
          if (cell.r == inicioy) {
            ws[i].s.fill = {
              patternType: 'solid',
              fgColor: { rgb: '156082' },
            };
            ws[i].s.font = {
              name: 'Aptos Narrow',
              sz: 10,
              bold: true,
              color: { rgb: 'ffffff' },
            };
            // Asegurar que los bordes de la cabecera sean medianos en el exterior
            ws[i].s.border.top = { style: 'medium' };
            ws[i].s.border.bottom = { style: 'medium' }; // Borde inferior de la cabecera
          }

          // Estilo de totales (mantenido de tu código)
          else if (cell.r == totales) {
            // ... (Lógica de totales y fórmulas) ...
            ws[i].s.border.top = { style: 'medium' }; // Borde superior de la fila de totales
            ws[i].s.border.bottom = { style: 'medium' }; // Borde inferior de la tabla
          }
        }
      }

      // Configuración de las columnas (anchos de columna)
      const colsConfig = Array.from({ length: x + 6 + iniciox }, (_, index) => ({
        wch: index === 0 ? 20 : (index === 1 ? 27 : (index === 2 ? 50 : (index === 5 ? 50 : 18)))
      }));
      ws['!cols'] = colsConfig.slice(0, x); // Ajusta para solo las columnas con datos

      // Añadimos la hoja al libro de trabajo
      XLSX.utils.book_append_sheet(wb, ws, 'Hoja 1');

    } else {
      console.log('El array está vacío - no hay datos para exportar');
    }
  }

  getExcelColumnName(index: number): string {
    let columnName = "";
    while (index >= 0) {
      columnName = String.fromCharCode(index % 26 + 65) + columnName;
      index = Math.floor(index / 26) - 1;
    }
    return columnName;
  }

  show(classComponent: any, ref: DynamicDialogRef, options: DynamicDialogConfig) {

    ref = this.dialogService.open(classComponent, options);

    // ref.onMaximize.subscribe((value) => {
    // });


    return ref
  }

  getMeses(): dropdownItems[] {
    const MESES: dropdownItems[] = [
      { label: 'TODOS', value: 'TODOS' },
      { label: 'ENERO', value: '01' },
      { label: 'FEBRERO', value: '02' },
      { label: 'MARZO', value: '03' },
      { label: 'ABRIL', value: '04' },
      { label: 'MAYO', value: '05' },
      { label: 'JUNIO', value: '06' },
      { label: 'JULIO', value: '07' },
      { label: 'AGOSTO', value: '08' },
      { label: 'SEPTIEMBRE', value: '09' },
      { label: 'OCTUBRE', value: '10' },
      { label: 'NOVIEMBRE', value: '11' },
      { label: 'DICIEMBRE', value: '12' }
    ]

    return MESES
  }

  getAnios(): dropdownItems[] {

    const anio: number = (new Date().getFullYear() + 1)
    var anios: dropdownItems[] = []
    for (let index = anio; index >= 2017; index--) {

      var item: dropdownItems = { label: (index).toString(), value: index }
      anios.push(item)

    }

    return anios

  }

  ExportExcel(options: optionExcelExport) {

    const ExcelJS = require('exceljs');


    if (options.sheets.length > 0) {

      // SE CREA EL EXCEL
      const workbook = new ExcelJS.Workbook();

      options.sheets.forEach((e, index) => {

        if (e.data.length > 0) {

          // SE CREA LA HOJA Y SE AGREGA SU NOMBRE
          const worksheet = workbook.addWorksheet(e.sheetName);

          // Creamos una copia de los datos para trabajar con ellos
          let datos = e.data.slice();

          // Posiciona los datos de la hoja incluye las cabeceras
          const inicioy = e.coordinates == undefined ? 1 : e.coordinates.y
          const iniciox = e.coordinates == undefined ? 1 : e.coordinates.x

          // Ubica la posicion inicial de la data
          const datax = iniciox + 1

          // Definimos las cantidades de filas y columnas de la data
          const county = datos.length
          const countx = Object.keys(datos[0]).length

          const rowTotaly = e.totalY == undefined ? false : e.totalY.status

          // Para los totales
          const totalx = countx + 1
          const totaly = county + iniciox + 1

          const footer = true

          // FILA PARA LOS TOTALES
          if (rowTotaly) {

            const headers = Object.keys(datos[0]);

            // Creamos una fila vacía para los totales con las mismas claves pero con valores vacíos
            const emptyRow = headers.reduce((acc, header) => {
              acc[header] = '';  // Asignamos un valor vacío a cada campo
              return acc;
            }, {});

            // Añadimos la fila vacía de totales al final de los datos
            datos.push(emptyRow);

          }

          // Agregamos cabeceras (fíjate que ExcelJS utiliza el método `addRow` para agregar filas)
          const headers = Object.keys(datos[0]).filter(header => header !== 'OBSERVACIONES');
          worksheet.addRow(headers);

          // Agregamos el contenido (filas de datos)
          datos.forEach((row, index) => {
            let rowData = headers.map(header => row[header]);
            worksheet.addRow(rowData);
          });

          //Configuramos los estilos de las celdas
          worksheet.eachRow({ includeEmpty: true }, function (row, rowIndex) {
            row.eachCell({ includeEmpty: true }, function (cell, colIndex) {
              // Estilos generales para todas las celdas
              cell.font = { name: 'Aptos Narrow', size: 9 };
              cell.alignment = { vertical: 'middle', horizontal: 'left' };
              cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF' } };

              // Agregar comentarios (Notas) en la columna 11 (Índice 11, que corresponde a la columna "OBSERVACIONES")


              // Agregar bordes
              if (rowIndex === 1) {
                // Cabecera
                cell.border = {
                  top: { style: 'thin' },
                  bottom: { style: 'thin' },
                  left: { style: 'thin' },
                  right: { style: 'thin' },
                };

                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '3475b1' } };
                cell.font = { name: 'Aptos Narrow', size: 10, bold: true, color: { argb: 'FFFFFF' } };

              } else {
                // if (colIndex === 11) {
                //   let comentario = (datos[rowIndex] && datos[rowIndex]['OBSERVACIONES']) ? datos[rowIndex]['OBSERVACIONES'].toString() : '';
                //   cell.note = comentario;  // Asignar el comentario a la celda
                //   // cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '3475b1' } };
                //   // cell.font = { name: 'Aptos Narrow', size: 10, bold: true, color: { argb: 'FFFFFF' } };
                // }
                // Bordes de celdas normales
                cell.border = {
                  top: { style: 'thin' },
                  bottom: { style: 'thin' },
                  left: { style: 'thin' },
                  right: { style: 'thin' },
                };
              }


              if (rowTotaly) {

                if (rowIndex == totaly) {
                  cell.font = { name: 'Aptos Narrow', size: 10, bold: true, color: { argb: 'FFFFFF' } };
                  cell.alignment = { vertical: 'middle', horizontal: 'center' };
                  cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '3475b1' } };

                }

              }

            });
          });

          if (e.sizeColumns && e.sizeColumns.length > 0) {

            worksheet.columns = headers.map((header, index) => {

              const columnConfig = e.sizeColumns.find(col => col.index === index + 1)

              return { key: header, width: columnConfig ? columnConfig.size : 13 }
            })

          }


          // TOTALES

          if (rowTotaly) {

            if (e.totalY.columns.length > 0) {

              e.totalY.columns.forEach(r => {

                // Esta funcion va de 1 a mas
                const columna = this.getExcelColumn(r);
                const celda = columna + totaly
                const desde = columna + datax
                const hasta = columna + (totaly - 1)

                worksheet.getCell(celda).value = { formula: 'SUM(' + desde + ':' + hasta + ')', result: 100 };

              })

            }

          }




        }

      })
      if (options.typeFile === '.csv') {
        workbook.csv.writeBuffer().then(buffer => {
          const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = options.fileName + options.typeFile;
          link.click();
        }).catch(err => {
          console.error('Error al generar el archivo Excel:', err);
        });
      } else if (options.typeFile === '.xlsx') {
        workbook.xlsx.writeBuffer().then(buffer => {
          const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = options.fileName + options.typeFile;
          link.click();
        }).catch(err => {
          console.error('Error al generar el archivo Excel:', err);
        });
      }
    }

  }

  getExcelColumn(index: number): string {
    let columnName = "";
    index -= 1;
    while (index >= 0) {
      columnName = String.fromCharCode(index % 26 + 65) + columnName;
      index = Math.floor(index / 26) - 1;
    }
    return columnName;
  }

  listaLTW: any[] = [];
  tamano: number = 0;
  db: IDBDatabase | null = null;
  registrosRecuperados: any[] = [];
  async logearse(): Promise<void> {
    return new Promise<void>((resolve, reject) => {  // Aseguramos que logearse devuelve una promesa
      // Verificamos si estamos en el navegador antes de acceder a IndexedDB
      if (typeof indexedDB !== 'undefined') {
        const request = indexedDB.open('DelfinGroup', 1); // Abrimos la base de datos 'DelfinGroup'

        request.onupgradeneeded = (event) => {
          this.db = (event.target as IDBRequest).result;
          if (this.db && !this.db.objectStoreNames.contains('registros')) {
            this.db.createObjectStore('registros', { keyPath: 'id' });  // Creamos un object store si no existe
          }
        };

        request.onsuccess = async (event) => {
          this.db = (event.target as IDBRequest).result;  // Guardamos la referencia de la DB
          console.log('Base de datos abierta con éxito');
          try {
            // Esperamos a que almacenarDatos se complete antes de continuar
            await this.almacenarDatos();
            // console.log('Todos los registros han sido almacenados en IndexedDB');
            resolve();  // Cuando todo se complete, resolvemos la promesa
          } catch (error) {
            console.error('Error al almacenar los datos:', error);
            reject(error);  // Si ocurre un error, rechazamos la promesa
          }
        };

        request.onerror = (event) => {
          console.error('Error al abrir la base de datos:', event);
          reject('Error al abrir la base de datos');
        };
      } else {
        console.error('indexedDB no está disponible en este entorno');
        reject('indexedDB no está disponible');  // Rechazamos si no está disponible
      }
    });
  }

  async almacenarDatos(): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {  // Especificamos que la promesa no retorna nada, es de tipo void
      if (this.db) {
        try {
          // this.listaLTW = await this.loadParametros_v2();  // Usamos await correctamente

          let parameters = await this.loadParametros_v2();

          parameters.map((r, index) => {
            const item: any = {
              id: 1 + index,
              tipo: r.tipo,
              datos: this.crypto.encrypt(JSON.stringify(
                {
                  codigo: r.codigo,
                  nombre: r.nombre,
                  via: r.via,
                  regimen: r.regimen,
                  lineaNegocio: r.lineaNegocio,
                  adicional1: r.adicional1,
                  adicional2: r.adicional2,
                  adicional3: r.adicional3,
                  pais: r.pais,
                  codpais: r.codpais
                }

              ), 'Lim@2023')
              // codigo:r.codigo,
              // nombre:r.nombre,
              // via:r.via,
              // regimen:r.regimen,
              // lineaNegocio:r.lineaNegocio,
              // adicional1:r.adicional1,
              // adicional2:r.adicional2,
              // adicional3:r.adicional3,
              // pais:r.pais,
              // codpais:r.codpais
            }
            this.listaLTW.push(item)
          })

          // console.log(data)
          // this.listaLTW.forEach((registro, index) => {
          //   registro.id = index + 1; // Asigna el 'id' incrementando desde 1
          // });
          // console.log(this.listaLTW)



          // Creamos una transacción para almacenar los datos
          const transaction = this.db.transaction('registros', 'readwrite');
          const store = transaction.objectStore('registros');

          this.listaLTW.forEach((registro) => {
            store.put(registro); // Almacenamos cada objeto en el object store
          });

          transaction.oncomplete = () => {
            console.log('Todos los registros han sido almacenados en IndexedDB');
            resolve(); // Resolvemos la promesa sin devolver valor (void)
          };

          transaction.onerror = (event) => {
            console.error('Error al almacenar los datos en IndexedDB', event);
            reject(event); // Rechazamos la promesa en caso de error
          };
        } catch (error) {
          console.error('Error al cargar parámetros', error);
          reject(error);  // Si algo falla al cargar los parámetros, rechazamos la promesa
        }
      } else {
        console.error('Base de datos no disponible');
        reject('Base de datos no disponible'); // Rechazamos si no hay acceso a la base de datos
      }
    });
  }


  obtenerDatos(tipo: any[]) {
    // console.log('entro a obtener datos')
    return new Promise((resolve, reject) => {
      if (typeof indexedDB !== 'undefined') {
        const request = indexedDB.open('DelfinGroup', 1); // Abrimos la base de datos 'DelfinGroup'

        request.onupgradeneeded = (event) => {
          this.db = (event.target as IDBRequest).result;
          if (this.db && !this.db.objectStoreNames.contains('registros')) {
            this.db.createObjectStore('registros', { keyPath: 'id' }); // Creamos un object store si no existe
          }
        };

        request.onsuccess = (event) => {
          this.db = (event.target as IDBRequest).result; // Obtener la base de datos cuando la apertura es exitosa
          const transaction = this.db.transaction('registros', 'readonly'); // Iniciar la transacción
          const store = transaction.objectStore('registros'); // Obtener el object store
          const requestGetAll = store.getAll(); // Obtener todos los registros
          requestGetAll.onsuccess = () => {

            this.registrosRecuperados = requestGetAll.result; // Guardamos los registros recuperados
            const parametros = []

            if (tipo[0].tipo === 'TODOS') {
              this.registrosRecuperados.map(x => {
                let datosDescifrados = JSON.parse(this.crypto.decrypt(x.datos, 'Lim@2023'));
                datosDescifrados.id = x.id;
                datosDescifrados.tipo = x.tipo;
                parametros.push(datosDescifrados);
              })
              resolve(parametros);
            } else {
              let listaFinal: any[] = []
              tipo.forEach(element => {
                let parametrofiltrado
                parametrofiltrado = this.registrosRecuperados.filter(x => {
                  return x.tipo === element.tipo
                })
                listaFinal.push(parametrofiltrado)
                // console.log(listaFinal)
              });
              // Combina todas las listas dentro de listaFinal en una sola lista
              const listaUnificada = [].concat(...listaFinal);
              // console.log(listaUnificada);

              listaUnificada.map(x => {
                let datosDescifrados = JSON.parse(this.crypto.decrypt(x.datos, 'Lim@2023'));
                datosDescifrados.id = x.id;
                datosDescifrados.tipo = x.tipo;
                parametros.push(datosDescifrados);
              })
              resolve(parametros);
            }
          };

          requestGetAll.onerror = (event) => {
            reject('Error al recuperar los datos desde IndexedDB'); // Rechazamos la promesa si ocurre un error
          };
        };

        request.onerror = (event) => {
          reject('Error al abrir la base de datos'); // Rechazamos la promesa si ocurre un error
        };
      } else {
        reject('IndexedDB no está soportado en este navegador'); // Si IndexedDB no está disponible
      }
    });
  }

  eliminarBaseDeDatos() {
    if (typeof indexedDB !== 'undefined') {
      const request = indexedDB.deleteDatabase('DelfinGroup'); // Nombre de la base de datos a eliminar

      request.onsuccess = () => {
        console.log('Base de datos eliminada con éxito');
      };

      request.onerror = (event) => {
        console.error('Error al eliminar la base de datos', event);
      };

      request.onblocked = () => {
        console.log('La base de datos está bloqueada y no se puede eliminar en este momento. Intentando nuevamente...');
        setTimeout(() => {
          const retryRequest = indexedDB.deleteDatabase('DelfinGroup');
          retryRequest.onsuccess = () => {
            console.log('Base de datos eliminada con éxito en el segundo intento');
          };
          retryRequest.onerror = (event) => {
            console.error('Error al eliminar la base de datos en el segundo intento', event);
          };
        }, 3000);  // Reintentar después de 3 segundos
      };
    } else {
      console.error('indexedDB no está disponible en este entorno');
    }
  }

  showLoadingScreen(option: loadingScreenType) {

    const dialogRef = this.dialog.open(LoadingScreenComponent, {
      data: {
        message: option.message
      },
      panelClass: 'loading-screen',
      disableClose: false
    });
    return dialogRef

  }

  getParameterByType(type: string): dropdownItems[] {

    let parametros = []

    const storedParams = this.storage.get('parametros')

    if (storedParams) {

      const PARAMETROS = JSON.parse(storedParams)

      parametros = PARAMETROS
        .filter(r => r.tipo === type)
        .map(r => {
          return JSON.parse(this.crypto.decrypt(r.encrypted, "L1ma2023@"))
        })

    }

    return parametros.map(r => { return { label: r.descripcion1, value: r.codigo } })

  }

  isValidDate(value: any): boolean {
    return value instanceof Date && !isNaN(value.getTime());
  }
  tryConvertToDate(value: any): Date | any {
    if (value === null || value === undefined) {
      return null;
    }

    // Si ya es un objeto Date válido, no hacemos nada
    if (this.isValidDate(value)) {
      return value;
    }
    const isoDateFormatRegex = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(.\d{3})?)?$/;
    // Si es una cadena, intentamos convertirla a Date
    if (typeof value === 'string') {
      // Solo si la cadena coincide con el formato esperado, intentamos crear un Date.
      if (isoDateFormatRegex.test(value)) {
        const date = new Date(value);
        if (this.isValidDate(date)) {
          return date;
        }
      }
    }

    // Si no es una cadena que se pueda convertir o ya es un Date válido, devolvemos el valor original
    return value;
  }

  convertAllDatesInObject<T extends Record<string, any>>(item: T): T {
    const newItem: T = {
      ...item
    }; // Crea una copia para no mutar el original

    for (const key in newItem) {
      if (Object.prototype.hasOwnProperty.call(newItem, key)) {
        newItem[key] = this.tryConvertToDate(newItem[key]);
      }
    }

    return newItem;
  }

  // convertDatesInObject<T extends Record<string, any>>(item: T, dateFields: string[]): T {
  //   const newItem = { ...item
  //   }; // Crea una copia para no mutar el original
  //   for (const field of dateFields) {
  //     if (newItem[field]) {
  //       (newItem as any)[field] = new Date(newItem[field]);
  //     } else {
  //       (newItem as any)[field] = null; // Asigna null si la fecha no existe
  //     }
  //   }
  //   return newItem;
  // }

  // Este método gestiona la apertura del diálogo y le pasa los datos
  openEntidadDialog(entidadData?: any): DynamicDialogRef {
    return this.dialogService.open(DialogFormularioComponent, {
      header: entidadData ? 'Editar Entidad' : 'Nueva Entidad',
      width: '70%',
      // Aquí se le pasan los datos al componente hijo
      data: entidadData
    });
  }

  async MessageDialog(options: {
    titulo?: string,
    mensaje?: string,
    icono?: string,
    cerrar?: boolean,
    referencia?: any,
    autocerrar?: boolean,
    tiempo?: number,
    tipo?: "ok" | "warning" | "error" | "",
    detalle?: string,
    pregunta?: {
      onAccept?: () => void,
      onReject?: () => void,
    },
    textoBtn?: {
      textoBtnOpcion1?: string,
      textoBtnOpcion2?: string,
    },
  }): Promise<boolean> {

    await new Promise(resolve => setTimeout(resolve, 150));

    const showMessageOptions = {
      titulo: options.titulo || '',
      mensaje: options.mensaje || '',
      icono: options.icono || 'icono-predeterminado',
      tipo: options.tipo || 'ok',
      referencia: options.referencia,
      cerrar: options.cerrar || false,
      autocerrar: options.autocerrar || false,
      tiempo: options.tiempo || 3000,
      detalle: options.detalle || '',
      pregunta: options.pregunta || null,
      textoBtn: options.textoBtn || '',
    };

    const abrirDialogo = () => {
      return this.dialogService.open(AlertDialogPrimeComponentComponent, {
        // header: showMessageOptions.titulo,
        width: '30vw',
        data: {
          message: showMessageOptions.mensaje,
          icono: showMessageOptions.icono,
          titulo: showMessageOptions.titulo,
          tipo: showMessageOptions.tipo,
          detalle: showMessageOptions.detalle,
          pregunta: !!showMessageOptions.pregunta,
          textoBtn: showMessageOptions.textoBtn,
        },
        styleClass: 'transparent-background',
        closeOnEscape: false,
        dismissableMask: false
      });
    }

    let ref = abrirDialogo();

    if (!ref) {
      await new Promise(resolve => setTimeout(resolve, 200));
      ref = abrirDialogo();
    }

    if (!ref) return false;

    if (showMessageOptions.autocerrar) {
      setTimeout(() => {
        ref.close();
      }, showMessageOptions.tiempo);
    }

    return new Promise<boolean>((resolve) => {
      ref.onClose.subscribe((result: boolean) => {
        resolve(!!result);

        setTimeout(() => {
          if (showMessageOptions.pregunta) {
            if (result) {
              showMessageOptions.pregunta?.onAccept?.();
            } else {
              showMessageOptions.pregunta?.onReject?.();
            }
          } else {
            if (showMessageOptions.cerrar) {
              showMessageOptions.referencia?.close();
            }
          }
        }, 100);
      });
    });
  }

  /**
  * Esta función Convierte una lista de objetos en un arreglo de objetos con las propiedades "label" y "value"
  *
  * @param list - Lista de objetos a convertir
  * @param label - Nombre de la propiedad que se usará como label
  * @param value - Nombre de la propiedad que se usará como valor
  */
  convertDropdownItems(list: any[], label: string, value: string): dropdownItems[] {
    var newList: dropdownItems[] = []

    const hasKeys = list.every(item => label in item && value in item)

    if (hasKeys) {
      newList = list.map(item => ({ label: item[label], value: item[value] }))
    } else {
      console.error("La lista no contiene esos atributos en todos los elementos.")
    }

    return newList
  }

  /**
  * El metodo retorna la lista de años desde 2017 hasta el año actual en formato "label" y "value"
  */
  getYear(): dropdownItems[] {
    const anio: number = (new Date().getFullYear())
    var anios: dropdownItems[] = []
    anios.push({ label: "TODOS", value: 0 })
    for (let index = anio; index >= 2017; index--) {
      var item: dropdownItems = { label: (index).toString(), value: index }
      anios.push(item)
    }
    return anios
  }

  async obtenerEntidadesPorTipo(tipo: number): Promise<any[]> {
    const request = <listarEntidadesRequest>{}
    request.entc_codigo = null
    request.tipe_codigo = tipo

    try {
      const response = await (this.servParametros.listarEntidades(request));
      console.log(response)
      return response['datos'].result;
    } catch (error) {
      return [];
    }
  }

  getFileIcon(fileName: string): string {
    const path = '../assets/Img/'
    if (!fileName) return path + 'logo_file.png';
    const extension = fileName.split('.').pop()?.toLowerCase();
    switch (extension) {
      case 'pdf':
        return path + 'logo_pdf.png';
      case 'doc':
      case 'docx':
        return path + 'logo_word.png';
      case 'ppt':
      case 'pptx':
        return path + 'logo_powerpoint.png';
      case 'xls':
      case 'xlsx':
        return path + 'logo_excel.png';
      case 'png':
      case 'jpg':
      case 'jpeg':
        return path + 'logo_photo.png';
      default:
        return path + 'logo_file.png';
    }
  }

  getMimeType(extension: string): string {
    const mimeTypes: { [key: string]: string } = {
      'png': 'image/png', 'jpg': 'image/jpeg', 'jpeg': 'image/jpeg', 'gif': 'image/gif', 'pdf': 'application/pdf', 'txt': 'text/plain', 'doc': 'application/msword',
      'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'xls': 'application/vnd.ms-excel',
      'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'zip': 'application/zip',
    };
    return mimeTypes[extension.toLowerCase()] || 'application/octet-stream';
  }

  multiEmailValidator(control: AbstractControl): ValidationErrors | null {
    const value = (control.value || '').trim();
    if (!value) return null;
    const emails = value
      .split(/[\s,;]+/)
      .map(email => email.trim())
      .filter(email => email.length > 0);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    const allValid = emails.every(email => emailRegex.test(email));
    return allValid ? null : { email: true };
  }

  obtenerIconoTipoArchivo(nombreArchivo: string): string {
    const extension = nombreArchivo.split('.').pop()?.toLowerCase();
    switch (extension) {
      case 'pdf':
        return '../assets/iconos/pdf.svg';
      case 'doc':
        return '../assets/iconos/documento.svg'
      case 'docx':
        return '../assets/iconos/word.svg'
      case 'jpg':
      case 'jpeg':
      case 'png':
        return '../assets/icons/picture.svg';
      case 'xls':
      case 'xlsx':
        return '../assets/iconos/excel.svg'
      case 'msg':
      case 'html':
      case 'htm':
        return '../assets/iconos/email.svg'
      default:
        return '../assets/icons/default-icon.svg';
    }
  }

  async getServicios(): Promise<any[]> {

    // this.repopricing.ListarServicios().subscribe(response => {
    //   console.log(response)
    //   return response.datos.result
    // })


    return await this.repopricing.ListarServicios().toPromise()

  }

  setFormatTable(data: any[]): any[] {
    return data.map((r, i) => ({ ...r, codeinterno: i, statustable: r.statustable ?? "E", checked: false }))
  }

  deepClone<T>(value: T): T {
    // Manejar tipos primitivos y funciones
    if (value === null || typeof value !== 'object') {
      return value;
    }

    // Clonar fechas
    if (value instanceof Date) {
      return new Date(value.getTime()) as any;
    }

    // Clonar arrays
    if (Array.isArray(value)) {
      return value.map(item => this.deepClone(item)) as any;
    }

    // Clonar objetos
    const clonedObj: any = {};
    for (const key in value) {
      if (Object.prototype.hasOwnProperty.call(value, key)) {
        clonedObj[key] = this.deepClone((value as any)[key]);
      }
    }

    return clonedObj;
  }

  /**
   *
   * @param option.message - Recibe el mensaje de carga
   * @returns
   */
  loadingScreen(option: loadingScreenType): DynamicDialogRef {
    const options = <DynamicDialogConfig>{
      appendTo: "body",
      showHeader: false,
      modal: true,
      style: { padding: 0 },
      data: { message: option.message },
      styleClass: "loading-prime",
      contentStyle: { padding: 0, height: "100%" }
    }
    const ref = this.dialogService.open(ALoadingScreenComponent, options);

    return ref
  }

  // ✅ Función: hoy sin desfase de zona horaria
  getToday(): Date {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate());
  }

  // ✅ Función: fecha de hace N meses sin desfase
  getDateMonthsAgo(months: number): Date {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth() - months, now.getDate());
  }

  // ✅ Esta función elimina el desfase horario
  getTodayFromDate(d: Date): Date {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }

  getFileName(nombre: string): string {
    const fecha = new Date();

    const yyyy = fecha.getFullYear();
    const mm = String(fecha.getMonth() + 1).padStart(2, '0');
    const dd = String(fecha.getDate()).padStart(2, '0');

    const hh = String(fecha.getHours()).padStart(2, '0');
    const min = String(fecha.getMinutes()).padStart(2, '0');

    return `${nombre}_${yyyy}-${mm}-${dd}_${hh}${min}.xlsx`;
  }

  /**
   * Exporta datos a un archivo Excel con formato personalizado
   * 
   * @param dt - Datos a exportar, exporta todas las filas visibles, si hay filtros aplicados en la tabla retorna solo los datos filtrados
   * @param metadata - Configuración de columnas (título, tipo, campo, etc.)
   * @param nombre_archivo - Nombre del archivo a generar (default: 'documento.xlsx')
   * @param footer - Indica si debe incluir fila de totales (default: false)
   * @param columnasTotales - Lista de campos que deben sumarse en el footer (default: [])
   * 
   * @example
   * // Exportar con totales en columnas específicas
   * exportarExcelGenerico(
   *   this.dataSource,
   *   this.columnas,
   *   'Reporte_Ventas.xlsx',
   *   true,
   *   ['monto', 'cantidad']
   * );
   * 
   * @returns void - Genera la descarga del archivo Excel
   */
  async exportarExcelGenerico(dt: any, metadata: newmetadate[], nombre_archivo: string = 'documento.xlsx', footer: boolean = false, columnasTotales: string[] = []): Promise<void> {
    try {
      // Importar exceljs dinámicamente
      const Excel = await import('exceljs');

      const datosFiltrados = dt.getDataFiltrada ? dt.getDataFiltrada() : dt;

      if (!datosFiltrados || datosFiltrados.length === 0) {
        this.showMessageError('No hay datos para exportar');
        return;
      }

      // Crear libro y hoja
      const workbook = new Excel.Workbook();
      const worksheet = workbook.addWorksheet('Reporte');

      // Agregar cabeceras con estilo
      const headerRow = worksheet.addRow(metadata.map(m => m.title));

      // Estilo para cabeceras: negrita, fondo azul, texto blanco, filtros
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FF4472C4' } // Azul
        };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      });

      // Habilitar filtros en la primera fila
      worksheet.autoFilter = {
        from: { row: 1, column: 1 },
        to: { row: 1, column: metadata.length }
      };

      // Agregar datos
      datosFiltrados.forEach((row: any) => {
        const fila = metadata.map(m => {
          let valor = row[m.field];

          switch (m.inputType) {
            case 'checkbox':
              return valor === true || valor === 1 || valor === '1' || valor === 'true' ? 'SI' : 'NO';
            case 'date':
            case 'datetime':
              if (valor) {
                const fecha = new Date(valor);
                return !isNaN(fecha.getTime())
                  ? (m.inputType === 'date' ? fecha.toLocaleDateString('es-PE') : fecha.toLocaleString('es-PE'))
                  : '';
              }
              return '';
            case 'decimal':
            case 'int':
              if (valor !== null && valor !== undefined && valor !== '') {
                const num = typeof valor === 'string' ? parseFloat(valor.replace(/[^0-9.-]/g, '')) : valor;
                return isNaN(num) ? '' : num;
              }
              return '';
            default:
              return valor?.toString() ?? '';
          }
        });

        const dataRow = worksheet.addRow(fila);

        // Formato para números
        dataRow.eachCell((cell, colNumber) => {
          const columnMeta = metadata[colNumber - 1];
          if (columnMeta?.inputType === 'decimal' || columnMeta?.inputType === 'int') {
            cell.numFmt = '#,##0.00';
            cell.alignment = { horizontal: 'right' };
          }
        });
      });

      // Agregar totales si se requiere
      if (footer) {
        const fieldsNumericos = metadata
          .filter(m => m.inputType === 'decimal' || m.inputType === 'int')
          .map(m => m.field);

        const columnasSumar = columnasTotales.length > 0 ? columnasTotales : fieldsNumericos;

        if (columnasSumar.length > 0) {
          // Agregar fila vacía antes de totales (opcional)
          worksheet.addRow([]);

          // Crear fila de totales completa
          const totalRowValues = new Array(metadata.length).fill('');
          totalRowValues[0] = 'TOTALES:';

          // Calcular y asignar sumas
          columnasSumar.forEach(field => {
            const colIndex = metadata.findIndex(m => m.field === field);
            if (colIndex !== -1) {
              let suma = 0;
              datosFiltrados.forEach((row: any) => {
                const valor = parseFloat(row[field]);
                if (!isNaN(valor)) suma += valor;
              });
              totalRowValues[colIndex] = suma;
            }
          });

          const totalRow = worksheet.addRow(totalRowValues);

          // Aplicar estilo a TODA la fila de totales
          totalRow.eachCell((cell, colNumber) => {
            // Fondo azul claro para toda la fila
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FF5B9BD5' } // Azul claro
            };

            // Bordes para todas las celdas
            cell.border = {
              top: { style: 'thin' },
              left: { style: 'thin' },
              bottom: { style: 'thin' },
              right: { style: 'thin' }
            };

            // Texto blanco y negrita para todas
            cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };

            // Alineación: centrado para números, izquierda para texto
            const columnMeta = metadata[colNumber - 1];
            if (columnMeta?.inputType === 'decimal' || columnMeta?.inputType === 'int') {
              cell.alignment = { horizontal: 'center' };
              cell.numFmt = '#,##0.00';
            } else {
              cell.alignment = { horizontal: 'left' };
            }
          });
        }
      }

      // Autoajustar ancho de columnas
      worksheet.columns.forEach((column, index) => {
        let maxLength = metadata[index]?.title.length || 10;
        column.eachCell({ includeEmpty: true }, (cell) => {
          const cellLength = cell.value ? cell.value.toString().length : 0;
          maxLength = Math.max(maxLength, cellLength);
        });
        column.width = Math.min(50, maxLength + 2);
      });

      // Generar archivo
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      // Descargar archivo
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = nombre_archivo.endsWith('.xlsx') ? nombre_archivo : nombre_archivo + '.xlsx';
      link.click();
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error('Error al exportar Excel:', error);
      this.showMessageError('Error al generar el archivo Excel');
    }
  }

  /**
 * Procesa y descarga un archivo a partir de un Base64
 * @param archivo Objeto que cumple con la interfaz itemsArchivosGenericoDTO
 */
  descargarArchivoBase64(archivo: itemsArchivosGenericoDTO) {
    if (!archivo || !archivo.imagenbyte) {
      throw new Error("El contenido del archivo está vacío.");
    }

    const nombre = archivo.nombre.toLowerCase();
    let mimeType = '';
    let extension = '';

    if (nombre.endsWith('.pdf')) {
      mimeType = 'application/pdf';
      extension = '.pdf';
    } else if (nombre.endsWith('.docx')) {
      mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      extension = '.docx';
    } else if (nombre.endsWith('.doc')) {
      mimeType = 'application/msword';
      extension = '.doc';
    } else {
      throw new Error("Formato de archivo no permitido. Solo se aceptan PDF o Word.");
    }

    const byteCharacters = atob(archivo.imagenbyte);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = archivo.nombre;

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }


}

export interface DataExportExcel {
  ColeccionExcel: ItemsDataExportExcel
}

export interface ItemsDataExportExcel {
  data: any[]
  cabeceras: string[]
}

export interface dropdownItems {
  label: string
  value: any
  cod?: any
}

export interface optionExcelExport {
  fileName: string
  sheets: optionsSheetExcel[]
  typeFile: '.csv' | '.xlsx';
}


export class optionsSheetExcel {
  data: any[]
  sheetName: string
  coordinates?: coordinatesExcel = { x: 1, y: 1 }
  totalY?: totalExcel = { status: false, columns: [] }
  totalX?: totalExcel = { status: false, columns: [] }
  sizeColumns?: ColumnExcelSize[]
}

export interface coordinatesExcel {
  x: number
  y: number
}

export interface totalExcel {
  status: boolean
  columns?: number[]
}

export interface addContentExcel {
  celda: string
  data: any
}

export interface ColumnExcelSize {
  index: number
  size?: number

}

export interface loadingScreenType {
  message: string
}
